import { RetryBox } from '@secretescapes/cauldron';
import styled, { BoxShadows, Scale, boxShadows, css } from '@secretescapes/falcon';
import { CommonStyledProps, mediaQuery } from '@utils/styles.utils';
import { innerSectionStructure } from '@features/Sale/SalePageMobile.styles';

export const Presentation = styled('div')`
  ${innerSectionStructure}

  padding: ${Scale.m};

  @media ${mediaQuery.tablet}, ${mediaQuery.desktop} {
    padding: 0;
    gap: ${Scale.l};
  }
`;

export const SelectionWrapper = styled('div')<CommonStyledProps>(
  ({ isMobile }) =>
    isMobile &&
    css`
      display: flex;
      flex-direction: column;
      border: ${({ theme }) => `${theme.color.grey10} 1px solid`};
      box-shadow: ${boxShadows[BoxShadows.level2]};
      border-radius: ${Scale.xxs};
      background-color: ${({ theme }) => theme.color.white};
    `
);

export const OffersWrapper = styled('div')<CommonStyledProps>(
  ({ isMobile }) =>
    isMobile &&
    css`
      ${innerSectionStructure}
      padding: 0 ${Scale.m};
    `
);

export const RetryBoxWrapper = styled('div')`
  height: 400px;
`;

export const StyledRetryBox = styled(RetryBox)`
  height: 400px;
`;
